angular.module('lsnBase.deprecated.models')
  .factory('ContactModelConstants', ['LsnContactModelConstants', function(LsnContactModelConstants) {
    return LsnContactModelConstants;
  }])
  .factory('ContactModel', ['LsnContactModelV1',
    function(LsnContactModelV1) {
      return LsnContactModelV1;
    }
  ]);